export const NewsRoutes = {
    news: (origin: string) => `${origin}/news`,
    newsFull: (origin: string) => `${origin}/news/fullnews`,
    newsFilters: (origin: string) => `${origin}/news/filters/company`,
};
